export default "__VITE_ASSET__74857a43__"